import { useContext } from "react";
import { NavToolbarSlotsContext } from "#nav-toolbar-slots-context";
export function useNavToolbarSlots() {
  return useContext(NavToolbarSlotsContext);
}
